import { unauthorizedEdgeFetch } from 'app/axios/edge'
import { ILoginFormValues } from '../../login/types'

export const LOGIN_ERRORS = {
  WRONG_CREDENTIALS: 110,
}

export const login = (params: ILoginFormValues) =>
  unauthorizedEdgeFetch.post('/users/login', params)
